import template from './investoren.html';
import controller from './investoren.controller';
import './investoren.scss';

let investorenComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default investorenComponent;



// WEBPACK FOOTER //
// ./client/app/common/forms/investoren/investoren.component.js